(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.GalleryOnPage = global.NewHomeSource.GalleryOnPage || {};
  global.NewHomeSource.GalleryOnPage.PlanTracking = global.NewHomeSource.GalleryOnPage.PlanTracking || {};

  class Ga4Events {
    /**
     * Handles carousel navigation events and dispatches a GA4 event.
     *
     * @param {Object} detail - The detail object from the event.
     * @param {string} component - The component where the event originated ('Lightbox' or 'OnPageGallery').
     */
    static carouselNavigationGa4Event(detail, component) {
      const { originator } = detail;

      const eventName =
        component === 'Lightbox'
          ? 'lightbox_experience'
          : 'gallery_detail_pages';

      const originatorMap = {
        nextArrow: {
          click_target: 'arrow_clicked',
          click_target1: 'forward_clicked',
        },
        previousArrow: {
          click_target: 'arrow_clicked',
          click_target1: 'backward_clicked',
        },
        dragNavigation: {
          click_target: 'image_swap',
        },
      };

      const params = originatorMap[originator] || { click_target: '' };

      const eventGa4 = {
        eventName,
        params,
        eventType: 'GA4Event',
      };

      document.body.dispatchEvent(
        new CustomEvent('trackOnDemandEvent', {
          detail: { data: eventGa4 },
        })
      );
    }

    /**
     * Handles video interaction events and dispatches a GA4 event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static videoInteractionGa4Event(detail) {
      const eventGa4 = {
        eventName: 'lightbox_experience',
        params: {
          click_target: 'lightbox_exp_open',
          click_target1: detail.interaction,
        },
        eventType: 'GA4Event',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }

    /**
     * Handles media click events and dispatches a GA4 event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static mediaClickGa4Event(detail) {
      const { originator } = detail;
      const mediaType = detail.isVideo ? 'video_play' : 'image_clicked';

      const originatorMap = {
        imageCountButton: {
          click_target: 'media_icon_clicked',
          click_target1: 'image_count',
        },
        videoCountButton: {
          click_target: 'media_icon_clicked',
          click_target1: 'video_count',
        },
        videoPlayButton: {
          click_target: 'lightbox_exp_open',
          click_target1: 'video_play',
          click_target2: 'play_arrow',
        },
      };

      const params = originatorMap[originator] || { click_target: 'lightbox_exp_open', click_target1: mediaType };

      const eventGa4 = {
        eventName: 'gallery_detail_pages',
        params,
        eventType: 'GA4Event',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }
  }

  global.NewHomeSource.GalleryOnPage.PlanTracking.Ga4Events = Ga4Events;
}(window));
